import { useState } from "react";

const STRENGTH_LEVELS = {
  0: { score: 0, label: "", color: "", percentage: 0 },
  1: { score: 1, label: "Weak", color: "#ff4d4f", percentage: 33 },
  2: { score: 2, label: "Medium", color: "#faad14", percentage: 66 },
  3: { score: 3, label: "Strong", color: "#52c41a", percentage: 100 },
};

const scorePassword = (pwd) => {
  const checks = [
    pwd.length >= 8,
    /[A-Z]/.test(pwd),
    /[a-z]/.test(pwd),
    /[0-9]/.test(pwd),
    /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd),
  ];
  const rawScore = checks.filter(Boolean).length;
  if (rawScore === 0) return STRENGTH_LEVELS[0];
  if (rawScore <= 2) return STRENGTH_LEVELS[1];
  if (rawScore <= 4) return STRENGTH_LEVELS[2];
  return STRENGTH_LEVELS[3];
};

// Shared password-strength meter used by every "change/set password" form.
export const usePasswordStrength = () => {
  const [passwordStrength, setPasswordStrength] = useState(STRENGTH_LEVELS[0]);

  const checkStrength = (pwd) => {
    setPasswordStrength(scorePassword(pwd || ""));
  };

  const reset = () => setPasswordStrength(STRENGTH_LEVELS[0]);

  return { passwordStrength, checkStrength, reset };
};
